/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Story_Bank_Close_MappingInputs */

const en_story_bank_close_mapping = /** @type {(inputs: Story_Bank_Close_MappingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Close Mapping`)
};

const de_story_bank_close_mapping = /** @type {(inputs: Story_Bank_Close_MappingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Close Mapping`)
};

const fr_story_bank_close_mapping = /** @type {(inputs: Story_Bank_Close_MappingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Close Mapping`)
};

const es_story_bank_close_mapping = /** @type {(inputs: Story_Bank_Close_MappingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Close Mapping`)
};

const it_story_bank_close_mapping = /** @type {(inputs: Story_Bank_Close_MappingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Close Mapping`)
};

const nl_story_bank_close_mapping = /** @type {(inputs: Story_Bank_Close_MappingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Close Mapping`)
};

const pl_story_bank_close_mapping = /** @type {(inputs: Story_Bank_Close_MappingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Close Mapping`)
};

const fi_story_bank_close_mapping = /** @type {(inputs: Story_Bank_Close_MappingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Close Mapping`)
};

const da_story_bank_close_mapping = /** @type {(inputs: Story_Bank_Close_MappingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Close Mapping`)
};

const sv_story_bank_close_mapping = /** @type {(inputs: Story_Bank_Close_MappingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Close Mapping`)
};

/**
* | output |
* | --- |
* | "Close Mapping" |
*
* @param {Story_Bank_Close_MappingInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const story_bank_close_mapping = /** @type {((inputs?: Story_Bank_Close_MappingInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Story_Bank_Close_MappingInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_story_bank_close_mapping(inputs)
	if (locale === "fr") return fr_story_bank_close_mapping(inputs)
	if (locale === "es") return es_story_bank_close_mapping(inputs)
	if (locale === "it") return it_story_bank_close_mapping(inputs)
	if (locale === "nl") return nl_story_bank_close_mapping(inputs)
	if (locale === "pl") return pl_story_bank_close_mapping(inputs)
	if (locale === "fi") return fi_story_bank_close_mapping(inputs)
	if (locale === "da") return da_story_bank_close_mapping(inputs)
	if (locale === "sv") return sv_story_bank_close_mapping(inputs)
	return en_story_bank_close_mapping(inputs)
});